import React from 'react';
import styled from 'styled-components';
import { FooterProps, FooterTypeCode } from './models';
import * as footerTypes from './types';

const footerTypeMap: Record<FooterTypeCode, React.ComponentType<FooterProps> | null> = {
  branded: footerTypes.BrandedFooter,
  minimal: footerTypes.MinimalFooter,
  authenticated: footerTypes.AuthenticatedFooter,
  hidden: null,
};

const FooterWrapper = styled.div`
  position: relative;
  z-index: 1;
`;

const DefaultFooterComponent = footerTypes.BrandedFooter;

const Footer: React.FC<FooterProps> = (props) => {
  if (props.type && footerTypeMap[props.type] === null) {
    return null;
  }

  const FooterComponent = props.type ? footerTypeMap[props.type]! : DefaultFooterComponent;
  return (
    <FooterWrapper>
      <FooterComponent {...props} />
    </FooterWrapper>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/Footer/Footer.tsx